import React from 'react'
import BookList from '../contents/Home/BookList';

const Home = () => {
  return (
    <div>
      <BookList/>
    </div>
  )
}

export default Home;
